async function CalcEntryLossFactor(entryFactor, velocity) {
    //Reference as "Loss Factor"
    if (
        entryFactor > 0 &&
        velocity > 0
    ) {

        let response;

        response = await fetch("https://api.cssi.co/Calc/CalculateEntryLossFactor", {
            method: "POST",
            body: JSON.stringify(
                {
                    "entryfactor": entryFactor,
                    "velocity": velocity
                }
            )
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default CalcEntryLossFactor;